import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetPatientHistoryOfSummaryDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/PatientHistoryOfSummary/GetDetail?` + params, null);

export const CreatePatientHistoryOfSummary = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PatientHistoryOfSummary/Create`, data, true);

export const UpdatePatientHistoryOfSummary = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PatientHistoryOfSummary/Update`, data, true);

export const GetFullPatientHistorySummary = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/PatientHistoryOfSummary/GetAllHistory?` + params,
    null,
  );

export const GetPatientHistorySummary = (params: any) =>
  GET_ENC(`${BASE_URL}/api/PatientHistoryOfSummary/GetHistory?` + params, null);

export const UpdateOPDHistoryByTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PatientHistoryOfSummary/UpdateByTemplate`, data);

export const GetPreviousOPDPatientHistoryDetail = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/PatientHistoryOfSummary/GetPreviousOPDPatientHistoryDetail?` +
      params,
    null,
  );

export const GetCheckPreviousOPD = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/PatientHistoryOfSummary/GetCheckPreviousOPD?` + params,
    null,
  );
